import React from 'react';
import * as ReactDOM from 'react-dom';
import * as ReactRouterDOM from 'react-router-dom';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './app/App';
import './styles/index.css';

// Renderer template releases are IIFE bundles and intentionally externalize
// these shared libraries. Expose the renderer's copies before loading a release.
Object.assign(window, { React, ReactDOM, ReactRouterDOM });

createRoot(document.getElementById('root')!).render(
  <StrictMode><BrowserRouter><App /></BrowserRouter></StrictMode>,
);
